import { getOrderWithRelation } from '@/api/order-api';
import { Skeleton } from '@/components/ui/skeleton';
import { useAuth } from '@/contexts/AuthContext';
import { OrderItemResponse, OrderResponse } from '@/types/order-type';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'wouter';
import MyContainer from '../MyContainer';
import InvoicePreviewCard from './invoice';
import { Customer } from '@/types/customer-type';
export default function OrderInvoicePage() {
  const { id } = useParams();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [order, setOrder] = useState<OrderResponse | null>(null);
  const [customer, setCustomer] = useState<Customer | null>(null);
  const [orderItems, setOrderItems] = useState<OrderItemResponse[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | string | null>(null);
  const [, setLocation] = useLocation();
  const { user, logout, isAuthenticated } = useAuth();
  const fetchOrder = async () => {
    setIsLoading(true);
    try {
      const orderWithRelation = await getOrderWithRelation(id as string);
      if (orderWithRelation.success) {
        setOrder(orderWithRelation.data.order);
        setCustomer(orderWithRelation.data.customer);
        setOrderItems(orderWithRelation.data.orderItems);
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        console.error('Error fetching order:', err.message);
        setError(err);
      } else {
        console.error('Unknown error:', err);
        setError(new Error('An unexpected error occurred'));
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (!id) return;
    fetchOrder();
  }, [id]);

  if (isLoading) {
    return (
      <div className="hidden lg:flex flex-col w-[420px] xl:w-[480px] bg-background border-l">
        <div className="p-6 space-y-6">
          <div className="space-y-2">
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-4 w-24" />
          </div>
          <div className="space-y-4">
            <div className="flex items-center space-x-4">
              <Skeleton className="h-12 w-12 rounded-full" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
          </div>
          <div className="space-y-3">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
          </div>
        </div>
      </div>
    );
  }

  if (order && customer) {
    return (
      <MyContainer enableBack={false}>
        <InvoicePreviewCard
          customer={customer}
          order={order}
          company={user?.store!}
          items={orderItems}
        />
      </MyContainer>
    );
  }
}
